module.exports = __webpack_public_path__ + "img/product-bg.d615c748.png";